import { render, staticRenderFns } from "./ManagerShiftEditorCopyFormData.vue?vue&type=template&id=e5623688&lang=pug&"
import script from "./ManagerShiftEditorCopyFormData.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditorCopyFormData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports